import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Download, X, Smartphone } from "lucide-react";
import { Brand } from "@/components/Brand";

const KEY = "rathri_install_popup_at";

export const InstallPopup = ({ install, installed }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (installed) return undefined;
    const last = Number(localStorage.getItem(KEY) || 0);
    if (Date.now() - last < 6 * 3600 * 1000) return undefined;
    const t = setTimeout(() => setOpen(true), 1200);
    return () => clearTimeout(t);
  }, [installed]);
  const close = () => { localStorage.setItem(KEY, String(Date.now())); setOpen(false); };
  if (!open) return null;
  return createPortal(
    <div data-testid="install-popup" className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-4" onClick={close}>
      <div className="absolute inset-0 bg-black/45" />
      <div onClick={(e) => e.stopPropagation()} className="relative w-full max-w-sm rounded-3xl bg-white shadow-2xl p-6 space-y-4 fade-up border-2 border-emerald-400/60">
        <button type="button" data-testid="install-popup-close" onClick={close} className="absolute top-3 right-3 btn-ghost w-8 h-8 rounded-full inline-flex items-center justify-center"><X size={14} /></button>
        <Brand size="sm" tagline={false} />
        <div className="flex items-center gap-3">
          <span className="w-12 h-12 rounded-2xl bg-emerald-500 text-white inline-flex items-center justify-center shrink-0 shadow-lg shadow-emerald-500/30"><Smartphone size={22} /></span>
          <div><p className="font-display text-base md:text-lg font-extrabold">ഉടൻ ഇൻസ്റ്റാൾ ചെയ്യൂ — RATHRI വെബ് ആപ്പ്</p><p className="text-xs text-[var(--muted-text)]">ഫോണിന്റെ ഹോം സ്ക്രീനിൽ ആപ്പ് പോലെ · Android, iPhone, Tablet</p></div>
        </div>
        <button type="button" data-testid="install-popup-button" onClick={() => { install(); close(); }} className="w-full h-12 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-sm inline-flex items-center justify-center gap-2 shadow-lg shadow-emerald-500/30 transition-colors"><Download size={16} /> ഇപ്പോൾ ഇൻസ്റ്റാൾ ചെയ്യുക</button>
        <button type="button" data-testid="install-popup-later" onClick={close} className="w-full text-xs text-[var(--muted-text)]">പിന്നീട്</button>
      </div>
    </div>,
    document.body
  );
};
